import { ArtifactsService } from '@inference.engine/api-client/web';
import {
  AudienceSessionWidgetSchema,
  type AudienceSessionWidget,
} from '@inference.engine/widgets/web';
import { inferenceHttp } from '@/lib/api/http-client';
import { logger } from '@/lib/utils/logger';

/**
 * Reads the self-contained audience-session snapshot stored on a saved
 * workspace artifact, for rendering the Library preview without the live
 * chat session.
 */
export const getSavedAudienceSessionSnapshot = async (
  workspaceId: string,
  artifactId: string,
): Promise<AudienceSessionWidget | null> => {
  const response = await ArtifactsService.getWorkspaceArtifactById({
    client: inferenceHttp,
    path: { workspaceId, artifactId },
  });

  if (!response.data) {
    throw new Error('No data returned from workspace artifact API');
  }

  // Validate the stored snapshot here instead of casting. A null/malformed `data`
  // field returns null (not a throw), so the preview renders its graceful fallback
  // rather than an error state.
  const parsed = AudienceSessionWidgetSchema.safeParse(response.data.data);
  if (!parsed.success) {
    logger.warn('getSavedAudienceSessionSnapshot: snapshot failed schema validation', parsed.error);
    return null;
  }

  return parsed.data;
};
